import { CountryCode, parsePhoneNumberFromString, PhoneNumber } from 'libphonenumber-js';

type PhoneNumberInfo = {
  isValid: boolean; // Валиден ли номер
  country: string | undefined; // Код страны (например, "RU")
  countryCallingCode: string | undefined; // Код звона в страну (например, "7" для России)
  nationalNumber: string | undefined; // Национальный номер (без кода страны)
  type: string | undefined; // Тип номера (например, "MOBILE", "FIXED_LINE")
  formatInternational: string; // Номер в международном формате
  formatNational: string; // Номер в национальном формате
  uri: string; // Номер в формате URI (tel:+79123456789)
  e164: string; // Номер в формате E.164
};

export const getPhoneNumberInfo = (
  phoneNumber: string,
  countryCode?: CountryCode | undefined
): PhoneNumberInfo | null => {
  const phoneNumberObj: PhoneNumber | undefined = parsePhoneNumberFromString(
    phoneNumber,
    countryCode
  );

  if (phoneNumberObj) {
    return {
      isValid: phoneNumberObj.isValid(),
      country: phoneNumberObj.country,
      countryCallingCode: phoneNumberObj.countryCallingCode,
      nationalNumber: phoneNumberObj.nationalNumber,
      type: phoneNumberObj.getType(),
      formatInternational: phoneNumberObj.formatInternational(),
      formatNational: phoneNumberObj.formatNational(),
      uri: phoneNumberObj.getURI(),
      e164: phoneNumberObj.format('E.164')
    };
  }

  return null;
};
